export const GenericFormActions = {
    OPTIONS_LOADED: "OPTIONS_LOADED",
    OPTIONS_RESET: "OPTIONS_RESET",
    OPTIONS_SELECTED: "OPTIONS_SELECTED",
    OPTIONS_FILTERED: "OPTIONS_FILTERED",
    SECTION_ADDED: "SECTION_ADDED",
    SECTION_REMOVED: "SECTION_REMOVED",
    DETAIL_MUTATED: "DETAIL_MUTATED",
    FORM_RESET: "FORM_RESET",
    FIELD_STATE_RESET: "FIELD_STATE_RESET",
    SAVE_MESSAGE_REQUESTED: "SAVE_MESSAGE_REQUESTED",
    SAVE_MESSAGE_REMOVED: "SAVE_MESSAGE_REMOVED",
    BLANK_FORM_CREATED: "BLANK_FORM_CREATED",
    FIELD_VALUE_UPDATED: "FIELD_VALUE_UPDATED",
    FIELD_VALUE_LOADED: "FIELD_VALUE_LOADED",
    FIELD_REMOVED_FROM_FORM: "FIELD_REMOVED_FROM_FORM",
    SAVE_SUCCESS: "SAVE_SUCCESS",
    SERVER_ERROR_MESSAGE_ADDED: "SERVER_ERROR_MESSAGE_ADDED",
    CLIENT_ERROR_MESSAGE_ADDED: "CLIENT_ERROR_MESSAGE_ADDED",
    ERRORS_CLEARED: "ERRORS_CLEARED",
    FIELD_ERROR_ADDED: "FIELD_ERROR_ADDED",
    FIELD_TOUCHED: "FIELD_TOUCHED",
    FORM_OPENED: "FORM_OPENED",
    FORM_CLOSED: "FORM_CLOSED",
    BLANK_GROUP_ADDED: "BLANK_GROUP_ADDED",
    GROUP_REMOVED: "GROUP_REMOVED",
    GROUPS_LOADED: "GROUPS_LOADED",
    PERMISSION_DENIED: "PERMISSION_DENIED",
};
